import type { FetchContext, FetchResponse } from 'ofetch'
import { $fetch } from 'ofetch'
import { useToast } from 'vue-toast-notification'
import { tr_async } from '~/assets/scripts/helpers'

export const $api = $fetch.create({
  onResponse(
    context: FetchContext & { response: FetchResponse<ResponseType> },
  ): Promise<void> | void {
    const message =
      context.response && context.response._data && typeof context.response._data === 'object'
        ? context.response._data
        : null

    if (context.response.status > 299) {
      if (context.response.status === 401) {
        tr_async(`You don't have permission to view this`).then((t) => {
          useToast({ position: 'bottom', duration: 5000 }).error(t)
        })
      } else if (context.response.status === 404) {
        tr_async(`Error - Not Found`).then((t) => {
          useToast({ position: 'top', duration: 5000 }).error(t)
        })
      } else if (context.response.status === 400) {
        if (message && message.error) {
          useToast({ position: 'top', duration: 5000 }).error(message.error)
        } else {
          tr_async(`Error - Bad Request`).then((t) => {
            useToast({ position: 'top', duration: 5000 }).error(t)
          })
        }
      } else if (context.response.status === 500) {
        tr_async(
          `An error has been encountered on the server - please try again, and contact support if this error persists`,
        ).then((t) => {
          useToast({ position: 'top', duration: 5000 }).error(t)
        })
      } else {
        tr_async(`Error`).then((t) => {
          useToast({ position: 'top', duration: 5000 }).error(`${t} - ${context.response.status}`)
        })
      }
    } else if (context.error) {
      tr_async(`Unspecified Error - see console`).then((t) => {
        useToast({ position: 'top', duration: 10000 }).error(t)
      })
      console.error(context.error)
    }

    if (message && (message.warning || message.warnings)) {
      const warnings = message.warnings ? message.warnings : [message.warning]
      for (const w of warnings) {
        tr_async(w).then((t) => {
          useToast({ position: 'top', duration: 5000 }).info(t)
        })
      }
    }
  },
})
